<template>
<div>
  <!-- <Breadcrumb :options="crumbOptions"></Breadcrumb> -->
  <div class="backStack-issue-wrap informationCreate">
    <From ref="form" layoutType="grid" :isErrorMessage="false" :optionList="formRows" :formRules="formRules" :defaultModel="defaultModel"> </From>
    <div class="backStack-issue-footer-wrap">
      <div class="submit-wrap">
        <a-button class="submit-audit" @click="invokeApi(0)" :loading="loading">保存</a-button>
        <a-button class="submit-audit" @click="invokeApi(1)" :loading="loading">保存并发布</a-button>
      </div>
    </div>
  </div>
</div>

</template>

<script>
// import Breadcrumb from '@/components/common/Breadcrumb'
import From from '../../components/formTable/form.vue'
import mixinsBackStack from '@/views/backstageSupport/mixins'
import { formRules, formRows } from './configs/configs.js'
import { addAnnounceInfo } from '@/api/announceApi.js'
import { getCurrentCrumb } from '@/utils/crumb.js'

export default {
  mixins: [mixinsBackStack],
  data() {
    return {
      loading: false,
      crumbOptions: [],
      formRows, // 表单item配置
      formRules, // 表单校验规则配置
      defaultModel: {
        operationType: '1'
      }, // 默认值
      typeText: ''
    }
  },
  components: {
    From,
    // Breadcrumb
  },
  methods: {
    // 处理面包屑
    settingCrumb(type) {
      const { path } = this.$route
      const newPath = path.replace('operation', type)
      const crumbOptions = getCurrentCrumb(newPath)
      this.crumbOptions = crumbOptions
    },
    clearForm() {
      this.defaultModel= { operationType: '1' }
    },
    async invokeApi(status) {
      const ref = this.$refs.form
      const validate = ref.validatedForm() // 校验表单是否有填写
      if (!validate) return
      try {
        const { picPath, ...formModel} = ref.formModel
        const pic = this.handlerPicPathIds(picPath).join(',')
        const params = {
          ...formModel,
          pic,
          status
        }
        const { code, msg } = await addAnnounceInfo(params)
        this.$apiStatusHandler(code, msg)
        ref.resetForm() // 请求成功重置表单
        this.clearForm() // 清空表单输入数据
        this.$router.push({ name:'informationAnnounce' })
      } catch (error) {
        this.$apiStatusHandler(99, error.msg)
      } finally {
        this.loading = false
      }
    },
    handlerPicPathIds(picPath) {
      if(!picPath) return []
      return picPath.reduce((pre, item) => {
        const {fileId} = item.response.data[0]
        pre.push(fileId)
        return pre
      }, [])
    },
  }
}
</script>
